import React from 'react'
import Loader from '../../shared/Loader';

export default function TwitterPost({ selectImage, postData, selectedPosts, loadMorePosts, isLoading, hasError, serviceItem, serviceType }) {
    const truncateString = (str) =>  {
        return str.length > 150 ? str.substring(0, 145) + "..." : str;
    }
    return (
        <div className=" py-5 px-2 lg:px-20 border border-gray-350 rounded-3xl">
            <p className="my-10 text-center"><span className="font-semibold">{selectedPosts?.length} posts</span> selected - <span className="font-semibold">{ }</span> per post</p>
            <div className="grid  grid-cols-1 lg:grid-cols-1 gap-3">

                {postData && postData?.map((post, idx) => (

                    post?.text  ? (

                        <div key={idx} className='flex flex-row gap-2 xl:gap-8 rounded-xl bg-gray-50 p-2 border-2 max-h-32'>
                            
                            <div className='flex border-r-2 p-0  xl:p-2 pr-2 xl:pr-6 min-w-min overflow-auto'>
                                <input className='' type={"checkbox"}  data-value= {truncateString(post?.text)} onClick={(e) => selectImage(e.target, null, serviceType)} id={post.tweet_id} data-code={post.tweet_id}></input>
                            </div>
                            <div className='self-center p-2 pr-6  line-clamp-1'>
                                <div className='text-xs bg-gray-50 hover:caret-fuchsia-200 rounded-xl'> <a>https://twitter.com/{post.user.username}/status/{post.tweet_id}</a>  </div>
                                <hr></hr>
                                <div>  {truncateString(post?.text)} </div>
                            </div>

                        </div>) : null
                ))}
            </div>
            <div className={`flex flex-row ${isLoading ? 'justify-center' : hasError ? 'justify-between' : 'justify-center'}`}>
                {isLoading ?
                    (<div className="my-5 mx-20"> <Loader styles={"w-12 h-12"}></Loader> </div>) :
                    hasError ? ((<p className="my-10 text-xl text-red-600">Failed loading, please try again!</p>)) : null}
                {!isLoading ? ((<button className="my-10 px-8 py-1 uppercase rounded-3xl border-2 border-pink-350 hover:text-pink-350 transition-all" type="button" value="Load More Posts" onClick={loadMorePosts}>Load More Posts</button>)) : null}
            </div>
        </div>
    )
}
